import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { ChevronUpDownIcon } from 'src/shared/components/icons/chevron-up-down-icon'
import { Iconmark } from 'src/shared/components/icons/logos/iconmark'
import { cn } from 'src/shared/utils/cn'

interface AuthHeaderProps {
  onHeaderClick?: () => void
  headerForText: string

  // Button on the right side of the header
  showHeaderButton?: boolean
  headerButtonText?: string
  onHeaderButtonClick?: () => void
  centerHeader?: boolean
}

export default function AuthHeader({
  onHeaderClick,
  headerForText,
  showHeaderButton = true,
  headerButtonText,
  onHeaderButtonClick,
  centerHeader = false,
}: AuthHeaderProps) {
  const navigate = useNavigate()

  const onIconMarkClick = () => {
    navigate(paths.root.getHref())
  }

  return (
    <div className={cn('flex w-full items-center justify-between gap-2', centerHeader && 'justify-center')}>
      <div className="flex flex-row items-center gap-2">
        <Iconmark className="h-[30px] w-[31px] text-secondary hover:cursor-pointer" onClick={onIconMarkClick} />
        <div
          className={cn('flex flex-row items-center gap-[6px] xs:gap-2', onHeaderClick && 'hover:cursor-pointer')}
          onClick={onHeaderClick}
        >
          <span className="shrink-0 text-[13px] font-semibold tracking-[-0.26px] text-secondary">
            for <span className="text-[18px] tracking-[-0.36px]">{headerForText}</span>
          </span>
          {onHeaderClick && (
            <div className="relative flex flex-col items-center justify-center text-primary">
              <ChevronUpDownIcon className="size-4" />
            </div>
          )}
        </div>
      </div>
      {showHeaderButton && (
        <div
          className="text-right text-[14px] font-semibold text-primary hover:cursor-pointer"
          onClick={onHeaderButtonClick}
        >
          {headerButtonText}
        </div>
      )}
    </div>
  )
}
